module.exports = {
  branch_name: '旭日',
  system_name: '青柠檬宿综合管理系统',
  website_title: ' - 青柠檬宿综合管理系统(旭日)',
  logic: {
    manual_meter: true,
  },
  constants: {
    utilities: {
      price: {
        electricity: 1,
      },
    },
  },
}




// WEBPACK FOOTER //
// ./config.override.js